import './SponsorWidget.css'
 import ConferenceBanner from '../assets/conf_banner_2.webp'
import { Link } from 'react-router-dom'


export default function SponsorWidget() {
  return (
    
    <div className="sponsorWid-wrap">
        {/* <h3>Featured Upcoming Conference</h3> */}
        {/* <ul>
            <li>
            <div className="sponsorWid-item">
              <a target="_blank" href="https://bit.ly/421IOjE">
            <img src={ConferenceBanner} alt="" className="sponsor-img" />
              </a>
            </div>  
            </li>
        </ul> */}
    </div>
  )
}
